import * as Yup from "yup";
import { UserChangePasswordFormProps } from "../../../types/user";
import { useRef } from "react";
import { Form, Formik, FormikProps } from "formik";
import FormBackGround from "../../common/Forms/FormBackGround/FormBackGround";
import FormHeader from "../../common/Forms/FormHeader/FormHeader";
import { TextField } from "../../common/VFX-UI";
import ActionBar from "../../common/ActionBar/ActionBar";
import { CustomFunction } from "./ChangePasswordScript";
import "./PasswordValidation.css";

const validationSchema = Yup.object().shape({
  currentPassword: Yup.string().required("Current password is required"),
  newPassword: Yup.string().required("New password is required"),
  confirmNewPassword: Yup.string().required("Confirm new password is required"),
});

const ChangePassword = (props: UserChangePasswordFormProps) => {
  const { status, initialVal, onClose, handleOnSubmit } = props;
  const formRef = useRef<FormikProps<any>>(null);
  const title = "Change Password";
  const saveInput = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  return (
    <FormBackGround>
      <FormHeader title={title} onClose={onClose} />
      <Formik
        onSubmit={handleOnSubmit}
        initialValues={initialVal}
        validationSchema={validationSchema}
        innerRef={formRef}
      >
        {({ handleChange }) => (
          <Form noValidate>
            <TextField
              label="Current Password"
              type="password"
              name="currentPassword"
              isRequired={true}
            />
            <TextField
              label="New Password"
              type="password"
              name="newPassword"
              isRequired={true}
              onKeyDown={()=>{CustomFunction()}}
            />

            <TextField
              label="Confirm New Password "
              type="password"
              name="confirmNewPassword"
              isRequired={true}
            />
            <div>
              <ul>
                <div
                  id="message"
                  className="change-password-requirement-wrapper"
                >
                  <h5>Password must follow the rules:</h5>
                  <p>
                    <span id="letter" className="password-invalid"></span>
                    <span style={{ paddingLeft: "15px" }}>
                      At least one <b>lowercase</b> letter
                    </span>
                  </p>
                  <p>
                    <span id="capital" className="password-invalid"></span>
                    <span style={{ paddingLeft: "15px" }}>
                      At least one <b>capital (uppercase)</b> letter
                    </span>
                  </p>
                  <p>
                    <span id="number" className="password-invalid"></span>
                    <span style={{ paddingLeft: "15px" }}>
                      At least one <b>number</b>
                    </span>
                  </p>
                  <p>
                    <span id="special" className="password-invalid"></span>
                    <span style={{ paddingLeft: "15px" }}>
                      At least one <b>special character</b>
                    </span>
                  </p>
                  <p>
                    <span id="length" className="password-invalid"></span>
                    <span style={{ paddingLeft: "15px" }}>
                      Minimum of <b>8 characters</b>
                    </span>
                  </p>
                </div>
              </ul>
            </div>
            <ActionBar
              submitHandler={saveInput}
              cancelHandler={onClose}
              submitText="Submit"
              cancelText="Cancel"
              isLoading={status === "pending"}
            ></ActionBar>
          </Form>
        )}
      </Formik>
    </FormBackGround>
  );
};

export default ChangePassword;
